<template>
  <b-button
    v-if="showTurnstileButton"
    :variant="variant"
    :size="size"
    :class="className"
    @click="onClickOpenTurnstile"
    :disabled="busy"
  >
    <i class="fa fa-fw fa-door-open" v-if="!busy"></i>
    <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
    {{ trans('open_turnstile') }}
    <img
      :src="image_url"
      style="visibility: hidden; width: 1px; height: 1px;"
    />
  </b-button>
</template>

<script>
  export default {
    props: {
      organization: Object,
      accessPoint: Object, // can be null
      size: {
        type: String,
        default: 'md',
      },
      className: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'primary',
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        image_url: null,
        port: null,
        val: 1,
      }
    },
    computed: {
      openTurnstileUsbSerial() {
        return !!this.accessPoint && this.accessPoint.relay_mode == 'usb'
      },
      openTurnstileLocalNetwork() {
        return !!this.accessPoint && !this.openTurnstileUsbSerial ?
          this.accessPoint.relay_local_network :
          false
      },
      openTurnstileUrl() {
        if (!!this.accessPoint) {
          return this.accessPoint.relay_url
        }
        return null
      },
      showTurnstileButton() {
        if (!this.accessPoint || !this.accessPoint.relay_mode) return false
        return this.openTurnstileUsbSerial || !!this.openTurnstileUrl
      },
    },
    methods: {
      onClickOpenTurnstile() {
        this.busy = true
        if (this.openTurnstileUsbSerial) {
          return this.openTurnstileWithSerialInterface()
        }
        if (this.openTurnstileLocalNetwork) {
          if (this.organization.auth_user.id == 1) {
            this.image_url = this.openTurnstileUrl + '&' + Math.random()*10000
            setTimeout(() => {
              this.busy = false
              _.toastSuccess(this, trans('turnstile_is_open'))
            }, 1000)
          } else {
            axios.get(this.openTurnstileUrl)
            .catch(error => {
              // Ignore any errors
            })
            .then(response => {
              this.busy = false
              _.toastSuccess(this, trans('turnstile_is_open'))
            })
          }
        } else {
          axios.post(this.openTurnstileUrl)
          .then(response => {
            this.busy = false
            _.toastSuccess(this, response.data.message)
          })
          .catch(error => {
            this.busy = false
            _.toastError(this, _.errorFromAjax(error))
          })
        }
      },
      openTurnstileWithSerialInterface() {
        if (!!this.port) return this.sendOpenCommandToPort()

        this.busy = true
        navigator.serial.getPorts()
        .then(ports => {
          //console.log('getPorts', ports)
          _.each(ports, port => {
            if (!this.port && port.getInfo().usbVendorId == 4292) {
              this.port = port
              this.sendOpenCommandToPort()
            }
          })
          if (!this.port) throw "Could not find a port. Request it."
        })
        .catch(error => {
          navigator.serial.requestPort({usbVendorId: 4292})
          .then(port => {
            this.port = port
            console.log('requestPort', this.port)
            this.sendOpenCommandToPort()
          })
          .catch(error => {
            this.busy = false
              console.log(error)
          })
        })
      },
      sendOpenCommandToPort() {
        this.busy = true
        this.port.open({baudRate: 9600})
        .then(result => {
          console.log('sendOpenCommandToPort open', result)
          const encoder = new TextEncoder()
          const writer = this.port.writable.getWriter()
          console.log(`AT+CH1=${this.val}`)
          writer.write(encoder.encode(`AT+CH1=${this.val}\r\n`))
          .then(result => {
            console.log('sendOpenCommandToPort write', result)
            setTimeout(() => {
              writer.releaseLock()
              this.port.close()
              if (this.val == 1) {
                _.toastSuccess(this, trans('turnstile_is_open'))
                this.val = 0
                setTimeout(this.sendOpenCommandToPort, 1000)
              } else {
                this.val = 1
                this.busy = false
              }
            }, 250)
          })
          .catch(error => {
            this.busy = false
            console.log(error)
            _.toastError(this, _.errorFromAjax(error))
            writer.releaseLock()
            this.port.close()
          })
        })
        .catch(error => {
          this.busy = false
          console.log(error)
          _.toastError(this, _.errorFromAjax(error))
          this.port = null
        })
      },
    },
    mounted() {
      window.openTurnstileButton = this
      this.$nextTick(() => {
        this.$emit('shown', this.showTurnstileButton)
      })
    },
  }
</script>